module.exports = __webpack_public_path__ + "img/wechat.7dc5637f.png";